import styled from "styled-components";

const PageSubtitle = styled.div`
    font-weight: bold;
    font-size: 16px;
    text-align: left;
    width: 100%;
    margin: auto;

    margin-bottom: 1em;
`

export default PageSubtitle